import React from "react";
// import './SizeChart.module.css'
import styles from "./SizeChart.module.css"

const SizeChartBottom = () => {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <div className={styles.tittle}>Men's Bottom Wear</div>
        <div className={styles.sizeChart}>Size Charts</div>
        <div className={styles.headerBorder}></div>
        <div className={styles.size}>CM | INCHES</div>
        <table>
          <tr>
            <th>SIZE</th>
            <th>TO FIT WAIST</th>
            <th>INSEAM LENGTH</th>
          </tr>
          <tr>
            <th>28</th>
            <th className={styles.tableDataStyle}>71.1 | 28</th>
            <th className={styles.tableDataStyle}>76.2 | 30</th>
          </tr>
          <tr>
            <th>30</th>
            <th className={styles.tableDataStyle}>76.2 | 30</th>
            <th className={styles.tableDataStyle}>76.2 | 30</th>
          </tr>
          <tr>
            <th>32</th>
            <th className={styles.tableDataStyle}>81.3 | 32</th>
            <th className={styles.tableDataStyle}>76.2 | 30</th>
          </tr>
          <tr>
            <th>34</th>
            <th className={styles.tableDataStyle}>86.4 | 34</th>
            <th className={styles.tableDataStyle}>76.2 | 30</th>
          </tr>
          <tr>
            <th>36</th>
            <th className={styles.tableDataStyle}>91.4 | 36</th>
            <th className={styles.tableDataStyle}>76.2 | 30</th>
          </tr>
        </table>

        <img
          src="https://cdn.kiwisizing.com/the-indian-garage-1653026723071.png"
          alt="size-chart"
        />

        <div className={styles.sizeDescription}>
          <p>
            <span>WAIST: </span>For measuring the waist first button the pants
            up. Next spread the pants flat on the surface, and remove any
            fullness and wrinkles from it.
          </p>
          <p>
            <span>FRONT RISE: </span>With the pants buttoned up, spread the
            pants on the floor or table; next remove all wrinkles, and measure
            this region by starting from crotch seam spot to the spot of the
            waistband.
          </p>
          <p>
            <span>HIP: </span>Measure across the hip area, this is in most cases
            1 1/2 inches below the zipper.
          </p>
          <p>
            <span>THIGH: </span>Starting at the crotch seam and ending 1–2
            inches below the hip area.
          </p>
          <p>
            <span>LENGTH: </span>With the pants buttoned up, spread the pants on
            a table, floor or any other flat surface, with outseams on both
            corners. After removing all wrinkles and any fullness, measure the
            length from the top of the waistband.
          </p>
          <p>
            <span>KNEE: </span>Next remove any wrinkles and fullness if present.
            Measure across the knee area.
          </p>
          <p>
            <span>INSEAM: </span>Having the pants buttoned up, spread the pants
            on a surface flat. Now measure the inseam gap from the crotch, at
            the spot where the front and back seams meet, exactly where, depends
            on the length you desire ultimately.
          </p>
          <p>
            <span>LEG OPENING: </span>Now in the last step follow the same
            pattern as the previous steps, which is spread the pants on a flat
            surface e.g. table or floor. After removing any fullness or
            wrinkles, start measurement beginning from one side of the leg
            opening to the other side of the leg opening.
          </p>

          <p className={styles.sizeDescriptionCaption}>
            Sizes can vary from 2-3 centimeters because they are measured by
            hand. 1inch=2.54cm The size matched on a label can differ from the
            one you have ordered
          </p>
        </div>
      </div>
    </div>
  );
};

export default SizeChartBottom;
